import { Input, Select, SelectItem, DateRangePicker } from "@heroui/react";
import { FilterCard } from "@/components/data-table";
import { parseDate } from "@internationalized/date";

const FilterData = ({ table, initialFilters, filterOptions = {} }) => {
    const { masterCashes = [] } = filterOptions;
    const { pending, setPending, isOpen, apply, clear } = table.filterPanel;

    const handleClear = () => {
        setPending(initialFilters);
        clear();
    };

    const dateRange =
        pending.start_date && pending.end_date
            ? {
                  start: parseDate(pending.start_date),
                  end: parseDate(pending.end_date),
              }
            : null;

    const handleDateRangeChange = (range) => {
        if (range) {
            setPending((prev) => ({
                ...prev,
                start_date: range.start.toString(),
                end_date: range.end.toString(),
            }));
        } else {
            setPending((prev) => ({
                ...prev,
                start_date: "",
                end_date: "",
            }));
        }
    };

    return (
        <FilterCard isVisible={isOpen} onClear={handleClear} onApply={apply}>
            <Input
                label="Pencarian"
                placeholder="Cari..."
                variant="flat"
                value={pending.search || ""}
                onValueChange={(val) =>
                    setPending((prev) => ({
                        ...prev,
                        search: val,
                    }))
                }
                isClearable
                onClear={() =>
                    setPending((prev) => ({
                        ...prev,
                        search: "",
                    }))
                }
            />

            <Select
                label="Tipe Transaksi"
                placeholder="Semua Tipe"
                variant="flat"
                selectedKeys={pending.type ? [String(pending.type)] : []}
                onSelectionChange={(keys) =>
                    setPending((prev) => ({
                        ...prev,
                        type: Array.from(keys)[0],
                    }))
                }
            >
                <SelectItem key="1">Pemasukan</SelectItem>
                <SelectItem key="2">Pengeluaran</SelectItem>
            </Select>

            <DateRangePicker
                label="Rentang Tanggal"
                value={dateRange}
                onChange={handleDateRangeChange}
                variant="flat"
            />

            <Select
                label="Dompet/Kas"
                placeholder="Pilih Kas"
                variant="flat"
                selectedKeys={
                    pending.master_cash_id
                        ? [String(pending.master_cash_id)]
                        : []
                }
                onSelectionChange={(keys) =>
                    setPending((prev) => ({
                        ...prev,
                        master_cash_id: Array.from(keys)[0],
                    }))
                }
            >
                {masterCashes.map((item) => (
                    <SelectItem key={item.value}>{item.title}</SelectItem>
                ))}
            </Select>
        </FilterCard>
    );
};

export default FilterData;
